import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { PipesModule } from "../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../directives/directives.module";
import { RedirectService } from "../../services/redirect.service";
import { InformationBoxSummaryService } from "../informationBoxSummary/information-box-summary.service";
import { OrdenReparacionComponent } from "./orden-reparacion.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        GridModule,
        DirectivesModule,
        PipesModule
    ],
    declarations: [
        OrdenReparacionComponent
    ],
    exports: [
        OrdenReparacionComponent
    ],
    providers: [
        RedirectService,
        InformationBoxSummaryService
    ]
})
export class OrdenReparacionModule { }
